var Curriculog = Curriculog || {};

Curriculog.Filters = (function ($, _, Backbone, Filters) {

	Filters = Backbone.View.extend({
		el: function() {
			return $('#curriculog-list-column-results-sorting');
		},

		initialize: function(options) {
      this.params = options.params;
			var html = this.render();
      if (this.params.cui_enabled) {
        this.$el.prepend(html);
      } else {
        this.$el.append(html);
      }

		},

		render: function() {
      var loggedIn = this.params.user.id > 0;
      var proposalTransparency = this.params.user.attributes.permissions.transparency_dashboard_view == 1;
      var template = 'ProposalList/proposalListFilters.html';
      if (this.params.cui_enabled) {
        template = 'ProposalList/proposalListFilters-CUI.html';
      }

      if (!loggedIn && !proposalTransparency) {
        return;
      }

      return nunjucks.render(template);
    }
	});

	return Filters;

})($, _, Backbone, Curriculog.Filters || {});
